import { BaseClient } from '../client';

interface PutAdminDealerRequest {
	idGrupoConcessionaria: number;
	razaoSocial: string;
	fantasia: string;
	cnpj: string;
	inscricaoEstadual: string;
	inscricaoMunicipal: string;
	telefone: string;
	celular: string;
	email: string;
	logradouro: string;
	numeroLogradouro: string;
	complementoLogradouro: string;
	bairro: string;
	cep: string;
	estado: string;
	cidade: string;
	responsavel: string;
	tagAtivo: string;
	tagDeferimento: string;
	indicacao: string;
	observacao: string;
	prioridade_minuto: number | null;
}

interface PutAdminDealerResponse {
	success: boolean;
	data: boolean;
	message: string;
}

export const putAdminDealer = async (
	requestBody: PutAdminDealerRequest,
	id: string,
	logotipo?: File | null
) => {
	const formData = new FormData();

	formData.append('RazaoSocial', requestBody.razaoSocial ?? '');
	formData.append('Fantasia', requestBody.fantasia ?? '');
	formData.append('Cnpj', requestBody.cnpj ?? '');
	formData.append('InscricaoEstadual', requestBody.inscricaoEstadual ?? '');
	formData.append('InscricaoMunicipal', requestBody.inscricaoMunicipal ?? '');
	formData.append('Telefone', requestBody.telefone ?? '');
	formData.append('Celular', requestBody.celular ?? '');
	formData.append('Email', requestBody.email ?? '');
	formData.append('Logradouro', requestBody.logradouro ?? '');
	formData.append('NumeroLogradouro', requestBody.numeroLogradouro ?? '');
	formData.append('Complemento', requestBody.complementoLogradouro ?? '');
	formData.append('Bairro', requestBody.bairro ?? '');
	formData.append('Cep', requestBody.cep ?? '');
	formData.append('Estado', requestBody.estado ?? '');
	formData.append('Cidade', requestBody.cidade ?? '');
	formData.append('Responsavel', requestBody.responsavel ?? '');
	formData.append('TagAtivo', requestBody.tagAtivo ?? '');
	formData.append('TagDeferimento', requestBody.tagDeferimento ?? '');
	formData.append('Indicacao', requestBody.indicacao ?? '');
	formData.append('Observacao', requestBody.observacao ?? '');
	formData.append('IdGrupoConcessionaria', String(requestBody.idGrupoConcessionaria ?? 0));
	formData.append('PrioridadeMinuto', String(requestBody.prioridade_minuto ?? 0));
	formData.append('Fax', '');
	formData.append('TextoPadrao', '');
	formData.append('TagGrau', '');

	if (logotipo) {
		formData.append('Logotipo', logotipo);
	}

	const response = await BaseClient.put<PutAdminDealerResponse>(
		`/Admin/Anuncios/Put/Update/Concessionaria?id_concessionaria=${id}`,
		formData,
		{
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		}
	).then((res) => res.data);

	return response;
};
